import { db } from "utils/firebaseConfig";
import getCertificationPost from "./getCertificationPost";

const deletePost = (collection, postId, setImages) => {
  db.collection(collection)
    .doc(postId)
    .delete()
    .then(() => {
      console.log("삭제성공");

      getCertificationPost("certificationImage", setImages);
    })
    .catch((error) => {
      console.error("에러: ", error);
    });
};

export default deletePost;
